
(function(){
    angular.module('tmx-app').factory('MasterService', ['tmxResource',
        function(tmxResource){

            var masterdata= tmxResource("masterdata");

            masterdata.getRetailer=getRetailer;


            function getRetailer(date,userId){
                return  masterdata.getByAction("DownloadMasterDateOfCustomerMaster?date="+date+"&userId="+userId,false);
            }

            return masterdata;

        }]);
})();
